<template>
  <div class="bg-login">
    <div class="d-flex justify-center align-center wrapper-content" fluid style="height: 100vh">
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" md="12" xl="10" sm="12">
            <v-row align="center" justify="center" class="d-flex flex-column">
              <v-col class="text-center" cols="12" md="6" lg="3" xl="3">
                <v-img src="../assets/logo_suim.png"></v-img>
              </v-col>

              <v-col cols="12" md="6" lg="3" xl="3">
                <v-form
                  lazy-validation
                  v-model="valid"
                  ref="formLogin"
                  @submit.prevent="validateUser"
                >
                  <v-row
                    align="center"
                    justify="center"
                    class="d-flex flex-column"
                  >
                    <small class="white--text">
                      {{ $utilFront.VERSION }}
                    </small>
                    <v-col class="my-3">
                      <v-text-field dark color="primary" label="Ingrese su nombre de usuario"
                        :rules="[loginRules.required]" v-model.trim="user" :disabled="validUsertxt" autocomplete="false"
                        :error="errorPass" :error-messages="msj" @keyup="
                          error = false;
                        msj = '';
                                                                                                      " append-icon="mdi-account"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-col v-show="validUser" class="text-center">
                    <v-btn fab color="primary" :disabled="sending || blockBtnNext" @click="validateUser()">
                      <v-icon dark large>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-col>

                  <template v-if="validPass">
                    <v-row align="center" justify="center" class="d-flex flex-column">
                      <v-col>
                        <v-text-field :append-icon="
                          show ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                        " @click:append="show = !show" :type="show ? 'text' : 'password'" dark color="primary"
                          label="Contraseña" :rules="[loginRules.required]" v-model.trim="password" :error="error"
                          :error-messages="msjPass" autofocus @keyup="
                            errorPass = false;
                          msjPass = '';
                                                                                                              "></v-text-field>
                      </v-col>

                      <v-col class="text-center">
                        <v-btn color="primary" type="submit" rounded @click="login" :disabled="sending">
                          {{ sending ? "Ingresando..." : "Ingresar" }}
                          <v-icon right>mdi-chevron-double-right</v-icon>
                        </v-btn>
                      </v-col>

                      <v-col class="text-center">
                        <v-btn dark plain @click="stepBack">
                          <v-icon left>mdi-chevron-left</v-icon>
                          Atras
                        </v-btn>
                      </v-col>
                    </v-row>
                  </template>
                </v-form>
                <template>
                  <br /><br />
                  <v-row>
                    <v-col class="text-center">
                      <router-link to="/app/config/control-cambios">
                        <v-btn color="primary" type="submit" rounded x-small outlined>
                          <v-icon left small>mdi-information</v-icon>
                          Acerca de
                        </v-btn>
                      </router-link>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script type="JS">
import { LoginRequest } from "@/core/request";
import { mapActions } from "vuex";
import decode from "jwt-decode";
import PRM from "../core/PermissionConstants";
export default {
  computed: {},
  data: () => ({
    show: false,
    error: false,
    errorPass: false,
    msjPass: "",
    msj: "",
    log: 1,
    valid: true,
    validUser: true,
    validUsertxt: false,
    validPass: false,
    loginRules: {
      required: (v) => !!v || "Campo requerido",
    },
    user: "",
    password: "",
    authToken: "",
    sending: false,
  }),

  methods: {
    ...mapActions(["saveUser"]),
    tab_GUID() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
      );
    },
    login() {
      if (this.$refs.formLogin.validate()) {
        this.sending = true;
        LoginRequest.loginUser(
          {
            username: this.user,
            password: this.password,
          },
          {
            headers: {
              Authorization_token: this.authToken,
            },
          }
        )
          .then((res) => {
            if (res.data.code === 200 && res.data.status === "OK") {
              localStorage.clear();
              const token = res.data.data.token;
              const pms = res.data.data.pms;
              localStorage.setItem("pms", pms);
              this.saveUser(token);
              sessionStorage.name = this.tab_GUID();
              window.name = sessionStorage.name;
              const token_decode = JSON.parse(
                localStorage.getItem("preferencias")
              );
              let newRoutes = [];
              if (token_decode.view_type === false) {
                let routes = this.$router.options.routes;
                for (let i = 0; i < routes.length; i++) {
                  const route = routes[i];

                  if (
                    this.$utilFront.nonEmpty(route) &&
                    this.$utilFront.nonEmpty(route.meta) &&
                    this.$utilFront.nonEmpty(route.meta.requireAuth) &&
                    this.$utilFront.nonEmpty(route.meta.prm) &&
                    route.meta.requireAuth === true &&
                    this.$utilFront.withPermission(route.meta.prm)
                  ) {
                    newRoutes.push(route);
                  }
                }
                const newRoute = newRoutes.slice(0, 1).shift();
                this.$router.push(newRoute.path);
              } else if (token_decode.view_type === true) {
                this.$router.replace("/Recepcion");
              }
            } else {
              this.$utilFront.notifications(
                res.data.data,
                "ERROR"
              );

              this.errorPass = true;
              this.msjPass = res.data.data.message;
            }
          })
          .catch((e) => {
            console.log(e);
            this.$utilFront.notifications("Ha ocurrido un error interno.", "ERROR");
          })
          .finally(() => {
            this.sending = false;
          });
      } else {
        this.$utilFront.notifications(
          "Verifique que los campos requeridos, no esten vacios",
          "ERROR"
        );
        this.error = true;
        this.msj = "Contraseña incorrecta";
      }
    },

    validateUser() {
      this.sending = true;
      LoginRequest.validateUsers({ username: this.user })
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.validUser = false;
            this.validPass = true;
            this.validUsertxt = true;
            this.authToken = res.data.data.token;
          } else {
            this.$utilFront.notifications(
              "Verifique que su nombre de usuario sea correcto",
              "ERROR"
            );
            this.error = true;
            this.msj = "Nombre de usuario no encontrado";
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },

    stepBack() {
      this.validUser = true;
      this.validPass = false;
      this.validUsertxt = false;
    },
    openChangeControlView(){
      //  this.$router.push("/app/config/control-cambios");
      //  this.$router.push({ name: "CONTROL_CHANGES" })
    }
  },
  computed: {
    blockBtnNext() {
      return this.user.trim() === "" ? true : false;
    },
  },
};
</script>
<!-- <style scoped>
.bg-login {
  background-image: url("../assets/suim_background.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #464646;
}
.img-fluid {
  max-width: 100%;
  height: auto;
}
</style> -->
<style lang="scss" scoped>
.bg-login {
  background-image: url("../assets/suim_background.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 100vh;
}

.loading-center {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
}

.form-head {
  text-align: center;
}

@media (min-width: 768px) {
  .img-fluid {
    width: 50%;
    height: 50%;
  }
}

@media (max-width: 768px) {
  .img-fluid {
    width: 70%;
    height: 100%;
  }
}

#sendLogin {
  margin-top: 20px;
}

/* Animacion de login  */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 2;
}

.button {
  text-transform: uppercase;
  font-weight: bold;
  height: 45px;
  letter-spacing: 2px;
}
</style>
